import {combineReducers} from "redux"

import meta from "./meta"
import config from "./config"
import content from "./content"
import preference from "./preference"
import accessReducer from "./access"
import request from "./request"
import siteReducer from "./sites"

export default combineReducers({
  meta,
  config,
  content,
  preference,
  access: accessReducer,
  request,
  sites: siteReducer

})
